import { Link } from "react-router-dom";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import NoteForm from "../components/CreditDebitNote/NoteForm";
import {
  CREDIT_DEBIT_NOTE_MENU_TITLE,
  CREDIT_DEBIT_NOTE_PATH,
} from "../components/CreditDebitNote/constants";

const breadcrumbLinkStyle = { textDecoration: "none", color: "inherit" };

/** /express/credit-debit-notes/new — an issued note is never edited, so there is no edit page. */
export default function CreditDebitNoteFormPage() {
  return (
    <Stack sx={{ padding: "8px 0" }}>
      <Stack direction="row" alignItems="center" mb={2}>
        <Link to={CREDIT_DEBIT_NOTE_PATH} style={breadcrumbLinkStyle}>
          <Typography variant="body1" fontWeight={500}>
            {CREDIT_DEBIT_NOTE_MENU_TITLE}
          </Typography>
        </Link>
        <Typography variant="body1" sx={{ mx: 1 }}>
          /
        </Typography>
        <Typography variant="body1" color="primary">
          ออกเอกสารใหม่
        </Typography>
      </Stack>
      <NoteForm />
    </Stack>
  );
}
